import { render, staticRenderFns } from "./PlatformDialog.vue?vue&type=template&id=701f26ef&scoped=true&"
import script from "./PlatformDialog.vue?vue&type=script&lang=js&"
export * from "./PlatformDialog.vue?vue&type=script&lang=js&"
import style0 from "./PlatformDialog.vue?vue&type=style&index=0&id=701f26ef&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "701f26ef",
  null
  
)

export default component.exports